import { AssetsService } from "@/common/api.service"
import { displayNotification } from "@/common/notification";

export const state = {
  assetCategories: [
    'tagImage',
    'restMedia',
    'pageBackground',
    'pageSidebarImage',
    'misc',
    'minimapImage'
  ],
  assets: [],
};

export const getters = {
}

export const mutations = {
  SET_ASSETS (state, assets) {
    state.assets = assets
  },
}

export const actions = {
  async FETCH_ASSETS ({ commit }) {
    const { data } = await AssetsService.get();
    commit('SET_ASSETS', data);
    return data;
  },

  UPDATE_ASSET ({ dispatch }, asset) {
    return AssetsService.update(asset._id, asset)
    .then(res => {
      displayNotification("Successfully Updated Asset", "success");
      return res.data.asset;
    })
    .catch(err => {
      displayNotification("Failed Updating Asset - " + err.response.data.errors.message, "warning");
      return null;
    })
    .finally(() => {
      dispatch('FETCH_ASSETS')
    })
  },  

  UPLOAD_ASSET ({ dispatch }, asset) {
    return AssetsService.upload(asset)
    .then(res => {
      displayNotification("Upload successful", "success");
      return res.data.asset;
    })
    .catch(err => {
      displayNotification("Upload failed - " + err.response.data.errors.message, "warning");
      return null;
    })
    .finally(() => {
      dispatch('FETCH_ASSETS')
    })
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}